import { agentsOnPageLoad } from '@/store/models/search'
import { FC, HTMLAttributes, memo } from 'react'
import {useStoreState} from "@/store";

const size = (height: number, width?: number) => ({
  height: `${height}rem`,
  width: width ? width + '%' : 'auto'
})

const Metric: FC = () => (
  <div className="lg:col-span-2">
    <div className="ShimmerBox mb-1" style={size(1.25)}></div>
    <div className="ShimmerBox" style={size(1.25, 30)}></div>
  </div>
)

const Avatar: FC<{ size: number }> = ({ size }) => (
  <div
    className="ShimmerBox"
    style={{ borderRadius: '50%', height: size, width: size }}
  />
)

const Shimmer: FC<HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  ...rest
}) => (
  <div
    className={`shadow-sm p-4 lg:p-6 rounded grid grid-cols-1 lg:grid-cols-12 ${className}`}
    data-testid="shimmer-row"
    {...rest}
  >
    <div className="hidden lg:grid lg:col-span-2">
      <Avatar size={112} />
    </div>

    <div className="lg:col-span-8 lg:mr-8">
      <div className="grid grid-cols-3 gap-2 lg:grid-cols-1 items-center mb-4 lg:mb-0">
        <div className="col-span-1 lg:hidden">
          <Avatar size={96} />
        </div>
        <div className="col-span-2 lg:col-span-1">
          <div className="mb-1 ShimmerBox" style={size(1.5, 33)}></div>
          <div
            className="text-sm text-gray-700 mb-4 ShimmerBox"
            style={size(1.5)}
          ></div>
        </div>
      </div>
      <div className="grid grid-cols-3 xl:grid-cols-6 gap-6 mb-6 lg:mb-0">
        {[...Array(3)].map((_, i) => (
          <Metric key={i} />
        ))}
      </div>
    </div>

    <div className="lg:col-span-2 grid grid-cols-2 lg:block">
      <div
        className="ShimmerBox lg:block lg:mb-4 mr-3 lg:mr-0 px-5"
        style={size(3)}
      ></div>
      <div className="ShimmerBox" style={size(3)}></div>
    </div>
  </div>
)

interface Props extends HTMLAttributes<HTMLDivElement> {
  rows?: number
}

const ShimmerRows: FC<Props> = ( rest) => {
  const { displayCount } = useStoreState(
      state => state.search
  )
  return (
    <div>
      {[...Array(displayCount)].map((_, i) => (
        <Shimmer key={i} {...rest} />
      ))}
    </div>
  )
}

export default memo(ShimmerRows)
